export const has8Characters = (password: string) => password.length >= 8;
export const hasUppercaseAndLowercase = (password: string) => /[a-z]/.test(password) && /[A-Z]/.test(password);
export const hasANumber = (password: string) => /[0-9]/.test(password);

export const validatePassword = (password: string): boolean => {
  return has8Characters(password) && hasUppercaseAndLowercase(password) && hasANumber(password);
};
